import { motion } from 'framer-motion';
import ReactMarkdown from 'react-markdown';
import type { CuesCard as CuesCardType } from '../../lib/workoutCards';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';

interface CuesCardProps {
  card: CuesCardType;
}

export function CuesCard({ card }: CuesCardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{ duration: 0.3 }}
      className="h-full"
    >
      <Card padding="lg" variant="elevated" className="h-full flex flex-col justify-center space-y-6">
        <div className="text-center space-y-3">
          <Badge variant="warning" size="md">Form Cues</Badge>

          <h3 className="text-3xl font-bold text-gray-900 dark:text-white">
            {card.exerciseName}
          </h3>
        </div>

        <div className="flex-1 flex items-center justify-center">
          <div className="prose prose-lg dark:prose-invert max-w-2xl">
            <ReactMarkdown>{card.cues || ''}</ReactMarkdown>
          </div>
        </div>
      </Card>
    </motion.div>
  );
}
